import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatomoTracker } from 'ngx-matomo';
import {
  matchConsultants,
  matches,
  requestMatches,
  requestMatchesLevels1,
} from 'src/interface/shared.interface';
import { buttons } from 'src/interface/shared.interface';
import { HelperFunctionsService } from 'src/services/helperFunctions/helper-functions.service';
import { ContextService } from 'src/services/platform/context.service';
import { PlatformService } from 'src/services/platform/platform-service.service';

@Component({
  selector: 'app-match-modal',
  templateUrl: './match-modal.component.html',
  styleUrls: ['./match-modal.component.scss'],
})
export class MatchModalComponent implements OnInit {
  selectedRequest?: requestMatchesLevels1 = this.contextService.selectedRequest;

  manualRequest: matches;
  salesRequests: requestMatches[];
  rawOptions: requestMatches[];
  tap: 'search' | 'manual' = 'search';
  selectedRequestDescription = '';
  manualDescription = '';
  type = this.contextService.openMatchModal;
  selectedConsultant: matchConsultants = this.contextService.selectedConsultant;
  toggleRequest = false;
  someSelected: boolean;
  note = '';
  addedNote = '';
  selectedStep = 0;
  loading: boolean;
  buttons: buttons[] = [
    {
      title: 'Cancel',
      disable: false,
      type: 'cancel',
      class: 'ghost',
    },
    {
      title: 'Add to request',
      disable: true,
      type: 'addToRequest',
      class: 'primary',
    },
  ];
  content = {
    icon: { name: '', class: '' },
    headline: 'Add consultant to a request',
    description: '',
  };
  sending: boolean;

  constructor(
    private platformService: PlatformService,
    public contextService: ContextService,
    private helperFunctions: HelperFunctionsService,
    private matomoTracker: MatomoTracker,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.getSearchRequests();
    if (this.type === 'explainerInfo') {
      this.content.icon = { name: 'sparkles', class: 'textHighlightMedium' };
      this.content.headline = 'Matching results';
      this.content.description =
        'The “Smart tips”-section includes two elements: “Text explanation” and “Keywords”. The text message is generated by OpenAI, by asking it to read the selected request and the consultant CV, and then explain why the consultant is a good fit for the request. It will also mention if the consultant has previously worked for the client of the request. \n The keywords are the overlapping keywords in the request and the consultant CV, as identified by matching. These keywords are ranked based on the number of times they appear in the consultant CV. There will be a maximum of 20 keywords shown.';
      this.buttons = [];
    }
    if (this.type === 'advancedSearch') {
      this.content.headline = 'Advanced search';
      this.buttons = [
        {
          title: '',
          disable: false,
          type: 'advancedSearch',
          class: 'none',
        },
        {
          title: 'Done',
          disable: false,
          type: 'advancedSearch',
          class: 'primary',
        },
      ];
    }
    if (['filters', 'match-filters'].includes(this.type)) {
      this.content.headline = 'Filters';
      this.buttons = [
        {
          title: 'Reset',
          disable: false,
          type: 'filters-reset',
          class: 'ghost',
        },
        {
          title: 'Show',
          disable: false,
          type: 'filters',
          class: 'primary',
        },
      ];
      this.contextService.resultsLength.subscribe((value: number) => {
        this.buttons[1].title = 'Show ' + value + ' results';
      });
    }
    if (['ctr', 'ctc'].includes(this.type)) {
      this.content.headline = 'Choose consultant';
      this.buttons = [
        {
          title: 'Cancel',
          disable: false,
          type: this.type,
          class: 'ghost',
        },
        {
          title: 'Confirm selection',
          disable: !this.contextService.selectedConsultant,
          type: this.type,
          class: 'primary',
        },
      ];
    }
    if (this.type === 'messaging') {
      this.content.headline = 'Send message';
      this.buttons = [
        {
          title: 'Cancel',
          disable: false,
          type: 'cancel',
          class: 'ghost',
        },
        {
          title: 'Previous',
          disable: true,
          type: 'back',
          class: 'secondary',
          step: 0,
        },
        {
          title: 'Next',
          disable: false,
          type: 'messaging',
          class: 'primary',
          step: 2,
        },
      ];
    }
    if (this.type === 'replyMessage') {
      this.content.headline = 'Message response';
      this.buttons = [
        {
          title: 'Close',
          disable: false,
          type: 'cancel',
          class: 'ghost',
        },
      ];
    }
    if (this.type === 'addNotes') {
      this.content.headline = 'Sales note';
      this.buttons[1] = {
        title: 'Save',
        disable: true,
        type: 'addNotes',
        class: 'primary',
      };
    }
    if (this.type === 'request') {
      this.content.headline = 'Choose request';
      this.buttons[1] = {
        title: 'Choose request',
        disable: true,
        type: 'requests',
        class: 'primary',
      };
    }
    if (this.contextService.selectedConsultant) {
      this.note = this.contextService.selectedConsultant.salesNotes ?? '';
    }
    if(this.type === 'longlist') {
      this.buttons[1].disable = !this.contextService.selectedConsultant || this.contextService.openMatchModal === 'addAnotherconsultant';
    }
  }

  menu(value: 'search' | 'manual') {
    this.tap = value;
  }
  validateButtons(event: string) {
    if (event === 'description') {
      this.buttons[2].disable =
        this.contextService.claiming.description.length < 1;
    }
  }
  action(button: buttons) {
    if (button.disable) {
      return;
    }
    if (['filters', 'filters-reset'].includes(button.type)) {
      if (button.type === 'filters-reset') {
        this.router.navigate([], {});
      }
      this.closeModal();
    }
    if (['ctr', 'ctc'].includes(button.type)) {
      if (button.title !== 'Cancel') {
        this.helperFunctions.route([
          'matching',
          button.type,
          this.selectedConsultant?.id ?? '',
        ]);
      }
      this.closeModal();
    }
    if (['advancedSearch'].includes(button.type)) {
      this.contextService.search.next('search');
      this.closeModal();
    }
    if (['cancel'].includes(button.type)) {
      this.closeModal();
    }
    if (button.type === 'addToRequest') {
      this.matomoTracker.trackEvent(
        this.type === 'addconsultant' ? 'Request' : 'Matching',
        'Added to - Longlist'
      );
      this.addToRequest();
    }
    if (button.type === 'requests') {
      this.continue();
    }
    if (button.type === 'addNotes') {
      this.save();
    }
    if (button.type === 'sendMessage') {
      this.sendMessage();
    }
    if (button.type === 'messaging') {
      if (!button.step) {
        return;
      }
      if (button.step > this.selectedStep) {
        this.selectedStep++;
        this.buttons[1].disable = false;
        if (this.selectedStep === button.step) {
          this.buttons[2].title = 'Send message';
          this.buttons[2].type = 'sendMessage';
        }
      }
      if (button.step === 2) {
        if (!this.contextService.claiming.description) {
          this.buttons[2].disable = true;
          return;
        }
      }
    }
    if (button.type === 'back') {
      if (button.step === undefined) {
        return;
      }
      if (this.buttons[2].type === 'sendMessage') {
        this.buttons[2].title = 'Next';
        this.buttons[2].type = 'messaging';
      }
      if (button.step < this.selectedStep) {
        this.selectedStep--;
        if (this.selectedStep === button.step) {
          button.disable = true;
        }
      }
      if (button.step === 0) {
        this.buttons[2].disable = false;
      }
    }
  }

  sendMessage() {
    if (!this.contextService.claiming.id) {
      return;
    }
    this.sending = true;
    this.platformService
      .declarationOfInterest(
        this.contextService.claiming.id,
        'put',
        this.contextService.claiming
      )
      .then((response) => {
        if (response.status === 200) {
          this.contextService.reRender.next('sentMessage');
          this.closeModal();
        }
      });
  }

  save() {
    if (
      !this.contextService.selectedRequest ||
      !this.contextService.selectedConsultant.crmId
    ) {
      return;
    }
    this.buttons[1].disable = true;
    this.platformService
      .postconsultantsalesStatus(
        this.contextService.selectedRequest.id,
        this.contextService.selectedConsultant.crmId,
        this.addedNote
      )
      .then((response) => {
        if (response.status === 202 || response.status === 200) {
          this.contextService.notification.next({
            description:
              this.selectedConsultant.firstName +
              ' sales notes have been updated',
            type: 'success',
            show: true,
            icon: 'sparkles',
          });
          this.contextService.reRender.next('longShortList');
        } else {
          this.contextService.notification.next({
            description: 'Oops, something went wrong. Try again',
            type: 'error',
            show: true,
            icon: 'info-circle-filled',
          });
        }
        this.closeModal();
      })
      .catch((error) => {
        console.log(error);
      });
  }
  continue() {
    if (this.selectedRequest) {
      this.helperFunctions.route(['matching', 'rtc', this.selectedRequest!.id]);
      this.contextService.selectedRequest = this.selectedRequest;
      if (this.contextService.manualRequest) {
        this.contextService.manualRequest.description = '';
      }
    }
    if (this.manualRequest) {
      this.helperFunctions.route([
        'matching',
        'rtc',
        'manual' + new Date().valueOf(),
      ]);
      this.contextService.selectedRequest = undefined;
      this.contextService.manualRequest = this.manualRequest as matches;
    }
    this.contextService.openMatchModal = 'close';
  }

  closeModal() {
    this.contextService.reRender.next('close');
    this.contextService.openMatchModal = 'close';
  }

  getDescription(id: string) {
    this.platformService.description(id, 'v2').then((response) => {
      this.selectedRequestDescription = response.description;
    });
  }

  search(event: Event) {
    const target = event.target as HTMLInputElement;

    if (target.value.length === 0) {
      this.salesRequests = [];
    }
    if (!this.rawOptions) {
      this.rawOptions = this.salesRequests;
    }

    if (target.value.length === 0) {
      this.salesRequests = this.rawOptions;
      return;
    }

    this.salesRequests = this.rawOptions.filter((x) => {
      const findbyTitle = x.title
        .toLowerCase()
        .replace(/\s/g, '')
        .includes(target.value.toLowerCase().replace(/\s/g, ''));
      const findbyCustomerName = x.customerName
        .toLowerCase()
        .replace(/\s/g, '')
        .includes(target.value.toLowerCase().replace(/\s/g, ''));
      if (!findbyTitle) {
        return findbyCustomerName;
      }
      return findbyTitle;
    });
  }

  getSearchRequests() {
    this.platformService.getRequestsList().then((response) => {
      this.salesRequests = response.data;
      this.salesRequests.map((x) => {
        if (this.selectedConsultant) {
          x.alreadyLonglist =
            x.longlist?.some(
              (z) => z.freelancerId === this.selectedConsultant.id
            ) ||
            x.shortlist?.some(
              (z) => z.freelancerId === this.selectedConsultant.id
            );
        }
        return x;
      });
    });
  }
  selected() {
    this.buttons[1].disable = !this.selectedConsultant;
  }
  selectRequest(request: requestMatchesLevels1) {
    this.selectedRequest = request;
    this.buttons[1].disable = !this.selectedRequest;
  }

  addToRequest() {
    this.loading = true;
    const freelance = {
      freelancerId: this.selectedConsultant.id,
      salesNotes: '',
    };

    this.platformService
      .longList(this.selectedRequest!.id, freelance)
      .then((response) => {
        if (response.status === 202 || response.status === 200) {
          this.contextService.notification.next({
            description:
              this.selectedConsultant.firstName +
              ' is added to the longlist of ' +
              this.selectedRequest!.title,
            type: 'success',
            show: true,
            icon: 'sparkles',
          });
          if (
            this.selectedRequest?.id === this.contextService.selectedRequest?.id
          ) {
            this.contextService.reRender.next('longShortList');
          }
        } else {
          this.contextService.notification.next({
            description: 'Oops, something went wrong. Try again',
            type: 'error',
            show: true,
            icon: 'info-circle-filled',
          });
        }
        // if (this.contextService.selectedConsultant) {
        //   this.contextService.selectedConsultant.id = '-1';
        //   this.contextService.selectedConsultant.crmId = '-1';
        // }
        this.closeModal();
      })
      .catch((error) => {
        console.log(error);
      });
  }

  blur() {
    if (this.manualRequest) {
      this.manualDescription = this.manualRequest?.description ?? '';
    }
  }

  manualInput(event: string) {
    if (event.length === 0) {
      this.buttons[1].disable = true;
      return;
    }
    const manualRequest = {
      id: 'manual',
      object: '',
      customer: '',
      customerName: '',
      title: event,
      companyLogo: '',
      description: event,
      type: 'manual',
    };
    this.selectedRequest = undefined;
    this.manualRequest = manualRequest;
    this.buttons[1].disable = false;
  }
  input(event: Event) {
    const target = event.currentTarget as HTMLInputElement;

    if (this.type === 'addNotes') {
      this.addedNote = target.innerText;
      this.selected();
      return;
    }
  }
  setSelectedRequest(event: requestMatchesLevels1) {
    this.selectedRequest = event;
    this.buttons[1].disable = true;
    this.selectedRequestDescription = '';
    if (event) {
      this.buttons[1].disable = false;
      this.getDescription(this.selectedRequest.id);
    }
  }
}
